import { render, staticRenderFns } from "./ProductListInCategory.vue?vue&type=template&id=5695f2d8&scoped=true&"
import script from "./ProductListInCategory.vue?vue&type=script&lang=js&"
export * from "./ProductListInCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProductListInCategory.vue?vue&type=style&index=0&id=5695f2d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5695f2d8",
  null
  
)

export default component.exports